import { Quote, Target, Eye, BadgeCheck } from "lucide-react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1591113898691-d9e9a8144c04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjb2xsZWdlJTIwbGlicmFyeSUyMGNhbXB1c3xlbnwwfHx8fDE3NzczMDc5MjN8MA&ixlib=rb-4.1.0&q=85";

export const About = () => (
    <section
        id="about"
        data-testid="about-section"
        className="section-bg relative bg-[var(--bg-page)] py-24 lg:py-32"
    >
        <div
            className="section-bg__media"
            style={{ backgroundImage: `url('${ABOUT_IMG}')` }}
            aria-hidden="true"
        />
        <div className="section-bg__veil veil-about" aria-hidden="true" />
        <div className="blob blob--green" style={{ width: 380, height: 380, top: -120, left: -120 }} aria-hidden="true" />
        <div className="blob blob--blue" style={{ width: 320, height: 320, bottom: -120, right: -100, animationDelay: "3s" }} aria-hidden="true" />

        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 relative">
            <div className="grid lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5 reveal">
                    <span className="section-rule eyebrow">About the Institution</span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] text-stone-900">
                        A legacy rooted in <em className="text-[var(--brand-green)] not-italic">care</em>,
                        built for the <em className="text-[var(--brand-blue)] not-italic">future</em> of pharmacy.
                    </h2>
                    <p className="mt-6 text-stone-600 text-base md:text-lg leading-relaxed max-w-md">
                        Located in the heart of Birbhum, Prasad Rudrik College of Pharmaceutical
                        Sciences is committed to nurturing skilled, ethical and industry-ready pharmacy
                        professionals through rigorous academics and modern infrastructure.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <span className="px-3 py-1.5 rounded-full bg-white border border-stone-200 text-xs tracking-wide text-stone-700">
                            <BadgeCheck size={14} className="inline -mt-0.5 mr-1 text-[var(--brand-green)]" /> PCI Aligned
                        </span>
                        <span className="px-3 py-1.5 rounded-full bg-white border border-stone-200 text-xs tracking-wide text-stone-700">
                            Est. by Prasad Educational Trust
                        </span>
                        <span className="px-3 py-1.5 rounded-full bg-white border border-stone-200 text-xs tracking-wide text-stone-700">
                            Birbhum, West Bengal
                        </span>
                    </div>
                </div>

                <div className="lg:col-span-7 grid grid-cols-2 gap-5 lg:gap-6">
                    <div className="col-span-2 zoom-wrap rounded-2xl reveal delay-1">
                        <img src={ABOUT_IMG} alt="Campus" className="w-full h-72 md:h-96 object-cover rounded-2xl" />
                    </div>

                    <div className="tactile-card p-6 md:p-7 reveal delay-2">
                        <Quote size={22} className="text-[var(--brand-green)]" />
                        <h3 className="font-display text-2xl mt-3 text-stone-900">Chairman&rsquo;s Message</h3>
                        <p className="text-sm text-stone-600 mt-3 leading-relaxed">
                            &ldquo;Education in pharmacy is service to humanity. We empower students with
                            knowledge, ethics and empathy to make a measurable difference in healthcare.&rdquo;
                        </p>
                        <div className="text-xs uppercase tracking-[0.18em] text-stone-500 mt-5">— Chairman, Prasad Educational Trust</div>
                    </div>

                    <div className="tactile-card p-6 md:p-7 reveal delay-3">
                        <Quote size={22} className="text-[var(--brand-blue)]" />
                        <h3 className="font-display text-2xl mt-3 text-stone-900">Principal&rsquo;s Message</h3>
                        <p className="text-sm text-stone-600 mt-3 leading-relaxed">
                            &ldquo;Our students don&rsquo;t just learn formulations — they learn responsibility.
                            Welcome to a campus where curiosity is celebrated and discipline is a habit.&rdquo;
                        </p>
                        <div className="text-xs uppercase tracking-[0.18em] text-stone-500 mt-5">— Principal</div>
                    </div>

                    <div className="tactile-card p-6 md:p-7 reveal delay-4">
                        <Target size={22} className="text-[var(--brand-green)]" />
                        <h3 className="font-display text-2xl mt-3 text-stone-900">Our Mission</h3>
                        <p className="text-sm text-stone-600 mt-3 leading-relaxed">
                            To deliver an industry-aligned pharmacy education backed by scientific rigour,
                            practical exposure and an unwavering commitment to patient safety.
                        </p>
                    </div>

                    <div className="tactile-card p-6 md:p-7 reveal delay-5">
                        <Eye size={22} className="text-[var(--brand-blue)]" />
                        <h3 className="font-display text-2xl mt-3 text-stone-900">Our Vision</h3>
                        <p className="text-sm text-stone-600 mt-3 leading-relaxed">
                            To be a regional centre of excellence that produces compassionate
                            pharmacists and translational researchers shaping community healthcare.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default About;
